import React from "react";
import { Stack, Typography } from "@mui/material";

const SectionHeader = ({ icon, title, color }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1} mb={2}>
      {React.cloneElement(icon, { sx: { color, fontSize: 20 } })}
      <Typography
        sx={{
          fontWeight: 700,
          color,
          fontSize: 18,
        }}
      >
        {title}
      </Typography>
    </Stack>
  );
};

export default SectionHeader;
